"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const result = {
    __schema: {
        types: [
            {
                kind: "INTERFACE",
                name: "ServiceChange",
                possibleTypes: [
                    {
                        name: "ServiceDeploymentChange"
                    },
                    {
                        name: "ServiceFeatureFlagChange"
                    }
                ]
            },
            {
                kind: "UNION",
                name: "Admin2",
                possibleTypes: [
                    {
                        name: "Group"
                    },
                    {
                        name: "User"
                    }
                ]
            },
            {
                kind: "INTERFACE",
                name: "Micros2Resource",
                possibleTypes: [
                    {
                        name: "KubernetesResource"
                    },
                    {
                        name: "ServiceCatalogResource"
                    }
                ]
            },
            {
                kind: "UNION",
                name: "MicrosEnvironments",
                possibleTypes: [
                    {
                        name: "MicrosStaticEnvironments"
                    },
                    {
                        name: "MicrosServiceEnvironments"
                    }
                ]
            },
            {
                kind: "INTERFACE",
                name: "MicrosServiceDeployment",
                possibleTypes: [
                    {
                        name: "MicrosServiceDeploymentRollout"
                    },
                    {
                        name: "MicrosServiceDeploymentNoRollout"
                    }
                ]
            },
            {
                kind: "UNION",
                name: "MicrosServiceType",
                possibleTypes: [
                    {
                        name: "MicrosEc2"
                    },
                    {
                        name: "MicrosKubeCompute"
                    }
                ]
            },
            {
                kind: "UNION",
                name: "SearchResult",
                possibleTypes: [
                    {
                        name: "Service"
                    },
                    {
                        name: "Tag"
                    },
                    {
                        name: "Category"
                    },
                    {
                        name: "CompliancePolicy2"
                    }
                ]
            },
            {
                kind: "UNION",
                name: "Admin",
                possibleTypes: [
                    {
                        name: "User"
                    },
                    {
                        name: "Group"
                    }
                ]
            }
        ]
    }
};
exports.default = result;
